(function () {
  'use strict';
  if (window.GemsCart && window.GemsCart.version === '1.3.0') {
    window.GemsCart.mount();
    return;
  }
  var ROOT_SELECTOR = '[data-gems-cart-dropdown]';
  var CART_MUTATION_RE = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[?#]|$)/i;
  var INTERNAL_SOURCE = 'gems-cart-controller';
  function route(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? String(window.Shopify.routes.root)
      : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\/+/, '');
  }
  function requestUrl(input) {
    if (typeof input === 'string') return input;
    return input && typeof input.url === 'string' ? input.url : '';
  }
  function requestMethod(input, init) {
    return String((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
  }
  function headerValue(headers, name) {
    if (!headers) return '';
    try {
      if (window.Headers) return new Headers(headers).get(name) || '';
    } catch (_) {}
    return '';
  }
  function responseJson(response) {
    return response.json().catch(function () { return {}; }).then(function (body) {
      if (!response.ok) {
        throw new Error(body.description || body.message || ('Cart request failed (' + response.status + ')'));
      }
      return body;
    });
  }
  function emit(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (_) {}
  }
  function validateCart(cart) {
    if (!cart || !Array.isArray(cart.items) || typeof cart.item_count !== 'number') {
      throw new Error('Invalid cart response');
    }
    return cart;
  }
  function delay(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }
  function CartController() {
    this.version = '1.3.0';
    this.managesDropdown = true;
    this.build = 'stable-cart-20261002';
    this.layoutLock = null;
    this.closingPromise = null;
    this.internalClose = false;
    this.root = null;
    this.syncPromise = null;
    this.revision = 0;
    this.interactions = 0;
    this.idleWaiters = [];
    this.mutationQueue = Promise.resolve();
    this.sequence = 0;
    this.removing = new Set();
    this.errorMessage = '';
    this.scrollList = null;
    this.scrollHandler = null;
    this.countObserver = null;
    this.countTargets = [];
    this.lastCountSignature = '';
    this.bound = false;
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onResize = this.onResize.bind(this);
  }
  CartController.prototype.mount = function () {
    this.root = document.querySelector(ROOT_SELECTOR);
    document.documentElement.setAttribute('data-gems-cart-controller', 'interaction-safe-20260924');
    if (!this.bound) {
      document.addEventListener('click', this.onClick, true);
      document.addEventListener('keydown', this.onKeydown, true);
      document.addEventListener('gems:cart-item-added', function (event) {
        this.commit({ source: 'gems-cart-item-added', item: event && event.detail && event.detail.item });
      }.bind(this));
      document.addEventListener('cart:updated', function (event) {
        var detail = event && event.detail ? event.detail : {};
        if (detail.source === INTERNAL_SOURCE || detail.source === 'gems-cart-page') return;
        this.commit({ source: detail.source || 'cart-updated', cart: detail.cart });
      }.bind(this));
      document.addEventListener('shopify:section:load', function () { this.mount(); }.bind(this));
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) this.commit({ source: 'pageshow', immediate: true });
      }.bind(this));
      window.addEventListener('resize', this.onResize, { passive: true });
      window.addEventListener('orientationchange', this.onResize, { passive: true });
      this.bound = true;
    }
    this.updateCounts(this.itemCount());
    this.bindCountObserver();
    this.bindScrollState();
  };
  CartController.prototype.itemCount = function () {
    if (!this.root) return 0;
    var count = Number(this.root.getAttribute('data-dd-item-count'));
    return Number.isFinite(count) ? count : 0;
  };
  CartController.prototype.sectionId = function () {
    return this.root ? (this.root.getAttribute('data-dd-section-id') || 'header') : 'header';
  };
  CartController.prototype.updateCounts = function (count) {
    var safe = Math.max(0, Number(count) || 0);
    var value = String(safe);
    document.querySelectorAll('[data-cart-count], [data-cart-popup-cart-quantity]').forEach(function (node) {
      if (node.textContent.trim() !== value) node.textContent = value;
      if (node.getAttribute('aria-label') !== value) node.setAttribute('aria-label', value);
    });
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (node) {
      node.classList.toggle('hide', safe <= 0);
    });
    this.lastCountSignature = this.countSignature();
  };
  CartController.prototype.countNodes = function () {
    var root = this.root;
    return Array.prototype.filter.call(document.querySelectorAll('[data-cart-count]'), function (node) {
      return !root || !root.contains(node);
    });
  };
  CartController.prototype.countSignature = function (nodes) {
    return (nodes || this.countNodes()).map(function (node) {
      return String(node.textContent || '').trim();
    }).join('|');
  };
  /*
    Every cart path in this theme already updates the header count. Observing that
    stable contract gives product forms, quick view, FBT, apps and cart-page edits
    one shared fallback without coupling this controller to their implementations.
  */
  CartController.prototype.bindCountObserver = function () {
    if (!window.MutationObserver) return;
    var nodes = this.countNodes();
    if (this.countObserver) this.countObserver.disconnect();
    this.countTargets = nodes;
    this.lastCountSignature = this.countSignature(nodes);
    this.countObserver = new MutationObserver(function () {
      var signature = this.countSignature(this.countTargets);
      if (signature === this.lastCountSignature) return;
      this.lastCountSignature = signature;
      this.commit({ source: 'header-count-change' });
    }.bind(this));
    nodes.forEach(function (node) {
      this.countObserver.observe(node, { childList: true, characterData: true, subtree: true });
    }.bind(this));
  };
  CartController.prototype.fetchCart = function () {
    return fetch(route('cart.js'), {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    }).then(responseJson).then(validateCart);
  };
  CartController.prototype.sectionUrl = function () {
    var url = new URL(window.location.href);
    url.hash = '';
    var ids = [this.sectionId()];
    var emptyPage = document.querySelector('[data-section-type="cart-page"] [data-gems-cart-empty]');
    var pageId = emptyPage && emptyPage.closest('[data-section-id]').getAttribute('data-section-id');
    if (pageId) ids.push(pageId);
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', ids.join(','));
    url.searchParams.set('_gems_cart_sync', String(++this.sequence));
    return url.toString();
  };
  CartController.prototype.fetchSection = function () {
    return fetch(this.sectionUrl(), {
      credentials: 'same-origin', cache: 'no-store',
      // HTML page negotiation is required. application/json makes Shopify
      // return /products/*.json or /cart.json instead of the sections map.
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(responseJson).then(function (payload) {
      if (!this.extractSection(payload)) throw new Error('Shopify did not return cart section HTML.');
      return payload;
    }.bind(this));
  };
  CartController.prototype.extractSection = function (payload) {
    var id = this.sectionId();
    var html = payload && payload.sections ? payload.sections[id] : payload && payload[id];
    return typeof html === 'string' && html.trim() ? html : '';
  };
  CartController.prototype.restoreEmptyCartPage = function (payload, cart) {
    if (!cart || !cart.item_count) return;
    var empty = document.querySelector('[data-section-type="cart-page"] [data-gems-cart-empty]');
    if (!empty) return;
    var page = empty.closest('[data-section-type="cart-page"]');
    var html = payload && payload[page.getAttribute('data-section-id')];
    if (typeof html !== 'string') throw new Error('Shopify did not return cart-page section HTML.');
    var template = document.createElement('template');
    template.innerHTML = html;
    var replacement = template.content.querySelector('[data-section-type="cart-page"]');
    if (!replacement) throw new Error('Cart-page root was not returned.');
    window.__gemsCartPageActiveScope = null;
    page.replaceWith(replacement);
    replacement.querySelectorAll('script').forEach(function (old) {
      var script = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (attr) { script.setAttribute(attr.name, attr.value); });
      script.textContent = old.textContent;
      old.replaceWith(script);
    });
  };

  CartController.prototype.freezeLayout = function () {
    if (this.layoutLock || !this.root) return;
    var popover = this.root.closest('[data-gems-cart-popover]');
    if (!popover || popover.hidden) return;
    var surface = popover.querySelector('.gems-cart-popover__surface');
    var viewport = this.root.querySelector('.dd-products-viewport');
    var nodes = [];
    [surface, viewport].forEach(function (node) {
      if (!node) return;
      var height = node.getBoundingClientRect().height;
      if (height <= 0) return;
      var properties = ['height', 'min-height', 'max-height', 'flex'];
      var saved = properties.map(function (name) {
        return { name: name, value: node.style.getPropertyValue(name), priority: node.style.getPropertyPriority(name) };
      });
      nodes.push({ node: node, saved: saved });
      ['height', 'min-height', 'max-height'].forEach(function (name) { node.style.setProperty(name, height + 'px', 'important'); });
      if (node === viewport) node.style.setProperty('flex', '0 0 ' + height + 'px', 'important');
    });
    popover.setAttribute('data-gems-cart-updating', '');
    this.layoutLock = { popover: popover, nodes: nodes };
  };
  CartController.prototype.thawLayout = function () {
    if (!this.layoutLock) return;
    this.layoutLock.nodes.forEach(function (entry) {
      entry.saved.forEach(function (property) {
        if (property.value) entry.node.style.setProperty(property.name, property.value, property.priority);
        else entry.node.style.removeProperty(property.name);
      });
    });
    this.layoutLock.popover.removeAttribute('data-gems-cart-updating');
    this.layoutLock = null;
    this.bindScrollState();
  };
  CartController.prototype.closeEmptyPopover = function () {
    if (this.closingPromise) return this.closingPromise;
    var popover = this.root && this.root.closest('[data-gems-cart-popover]');
    var shell = popover && popover.closest('[data-gems-header-shell]');
    var trigger = shell && Array.prototype.find.call(shell.querySelectorAll('[data-gems-cart-toggle]'), function (button) {
      return button.getAttribute('aria-expanded') === 'true';
    });
    if (!popover || popover.hidden || !trigger) return Promise.resolve();
    var controller = this;
    var animation;
    function finish() {
      // The header remains responsible for ARIA, focus restoration and scroll locks.
      if (!popover.hidden && trigger.getAttribute('aria-expanded') === 'true') {
        controller.internalClose = true;
        try { trigger.click(); } finally { controller.internalClose = false; }
      }
      // Some header implementations set `hidden` only after their exit transition.
      // Keep our opacity at zero until that lifecycle finishes, then release it.
      if (popover.hidden || trigger.getAttribute('aria-expanded') !== 'false') {
        if (animation) animation.cancel();
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        var timer;
        var observer = new MutationObserver(check);
        function done() {
          observer.disconnect(); window.clearTimeout(timer);
          if (animation) animation.cancel(); resolve();
        }
        function check() {
          if (popover.hidden || trigger.getAttribute('aria-expanded') !== 'false') done();
        }
        observer.observe(popover, { attributes: true, attributeFilter: ['hidden'] });
        observer.observe(trigger, { attributes: true, attributeFilter: ['aria-expanded'] });
        timer = window.setTimeout(function () {
          if (trigger.getAttribute('aria-expanded') === 'false') popover.hidden = true;
          done();
        }, 400);
        check();
      });
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !popover.animate) {
      return finish();
    }
    // Do not animate transform: the existing header may use it for positioning.
    animation = popover.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140, easing: 'ease-out', fill: 'forwards' });
    this.closingPromise = animation.finished.catch(function () {}).then(finish).finally(function () { controller.closingPromise = null; });
    return this.closingPromise;
  };

  CartController.prototype.applySection = function (payload, cart) {
    if (!this.root) this.root = document.querySelector(ROOT_SELECTOR);
    if (!this.root) return false;
    var html = this.extractSection(payload);
    if (!html) return false;
    var template = document.createElement('template');
    template.innerHTML = String(html).trim();
    var replacement = template.content.querySelector(ROOT_SELECTOR);
    if (!replacement) throw new Error('Cart dropdown root was not returned in section HTML.');
    var list = this.root.querySelector('.products-list');
    var scrollTop = list ? list.scrollTop : 0;
    // Keep the dropdown root, CSS and scroll container alive. Only patch changed content.
    var current = this.root;
    Array.prototype.forEach.call(replacement.attributes, function (attribute) {
      if (current.getAttribute(attribute.name) !== attribute.value) current.setAttribute(attribute.name, attribute.value);
    });
    var nextList = replacement.querySelector('.products-list');
    if (list && nextList) {
      var rows = new Map();
      Array.prototype.forEach.call(list.children, function (row) { rows.set(row.getAttribute('data-dd-line-key'), row); });
      var desired = Array.prototype.slice.call(nextList.children);
      var wanted = new Set(desired.map(function (row) { return row.getAttribute('data-dd-line-key'); }));
      rows.forEach(function (row, key) { if (!wanted.has(key)) row.remove(); });
      var cursor = list.firstElementChild;
      desired.forEach(function (fresh) {
        var key = fresh.getAttribute('data-dd-line-key');
        var row = rows.get(key);
        if (!row || !row.isConnected) row = fresh;
        else {
          Array.prototype.forEach.call(fresh.attributes, function (attribute) {
            if (row.getAttribute(attribute.name) !== attribute.value) row.setAttribute(attribute.name, attribute.value);
          });
          if (row.innerHTML !== fresh.innerHTML) row.innerHTML = fresh.innerHTML;
        }
        if (row !== cursor) list.insertBefore(row, cursor);
        cursor = row.nextElementSibling;
      });
      list.scrollTop = scrollTop;
    }
    ['.no-items', '.dd-footer'].forEach(function (selector) {
      var node = current.querySelector(selector);
      var fresh = replacement.querySelector(selector);
      if (node && fresh && node.innerHTML !== fresh.innerHTML) node.innerHTML = fresh.innerHTML;
    });
    var empty = current.querySelector('.no-items');
    var full = current.querySelector('.has-items');
    if (empty) empty.style.display = cart.item_count ? 'none' : '';
    if (full) full.style.display = cart.item_count ? '' : 'none';
    this.status(this.errorMessage);
    this.updateCounts(cart && cart.item_count);
    this.bindCountObserver();
    this.bindScrollState();
    return true;
  };
  CartController.prototype.commit = function (detail) {
    var data = detail || {};
    // Invalidate immediately, not after a debounce: an old read must never
    // replace a row whose next interaction has already begun.
    this.revision += 1;
    return this.sync(data.source || 'cart-change', data.immediate ? 0 : 24);
  };
  CartController.prototype.beginInteraction = function () {
    this.freezeLayout();
    this.interactions += 1;
    this.revision += 1;
    var released = false;
    return function () {
      if (released) return;
      released = true;
      this.interactions -= 1;
      if (!this.interactions) this.idleWaiters.splice(0).forEach(function (resolve) { resolve(); });
      return this.commit({ source: 'interaction-complete', immediate: true });
    }.bind(this);
  };
  CartController.prototype.whenIdle = function () {
    if (!this.interactions) return Promise.resolve();
    return new Promise(function (resolve) { this.idleWaiters.push(resolve); }.bind(this));
  };
  CartController.prototype.enqueueMutation = function (operation) {
    // Never retry a write automatically. A failed request may have reached
    // Shopify. Queue recovery only allows the NEXT independent action to run.
    var result = this.mutationQueue.then(operation);
    this.mutationQueue = result.catch(function () {});
    return result;
  };
  CartController.prototype.sync = function (source, wait) {
    if (this.syncPromise) return this.syncPromise;
    this.syncPromise = Promise.resolve().then(async function () {
      if (wait) await delay(wait);
      try {
        for (;;) {
          await this.whenIdle();
          var revision = this.revision;
          var cart = await this.fetchCart();
          if (this.interactions || revision !== this.revision) continue;
          var sectionPayload = null;
          if (this.root) {
            try { sectionPayload = await this.fetchSection(); }
            catch (error) { console.warn('[GEMS cart] Dropdown render failed; cart state is still current.', error); }
          }
          if (this.interactions || revision !== this.revision) continue;
          if (cart.item_count === 0 && this.itemCount() > 0) {
            await this.closeEmptyPopover();
            if (this.interactions || revision !== this.revision) continue;
          }
          this.updateCounts(cart.item_count);
          if (sectionPayload) {
            try {
              this.applySection(sectionPayload, cart);
              this.restoreEmptyCartPage(sectionPayload, cart);
            } catch (error) {
              console.warn('[GEMS cart] Section update failed.', error);
            }
          }
          emit('gems:cart-synced', { cart: cart, source: source || INTERNAL_SOURCE });
          emit('cart:updated', { cart: cart, source: INTERNAL_SOURCE, trigger: source || '' });
          if (this.interactions || revision !== this.revision) continue;
          return cart;
        }
      } catch (error) {
        console.warn('[GEMS cart] Synchronization failed.', error);
        return null;
      } finally {
        this.syncPromise = null;
        if (!this.interactions) this.thawLayout();
      }
    }.bind(this));
    return this.syncPromise;
  };
  CartController.prototype.status = function (message) {
    this.errorMessage = message || '';
    if (!this.root) return;
    var node = this.root.querySelector('[data-dd-status]');
    if (node) node.textContent = message || '';
  };
  CartController.prototype.remove = function (button) {
    var key = button.getAttribute('data-dd-remove-key');
    var row = button.closest('[data-dd-line-key]');
    if (!key || !row || this.removing.has(key)) return;
    var variantId = row.getAttribute('data-dd-variant-id');
    this.removing.add(key);
    var release = this.beginInteraction();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    row.setAttribute('aria-busy', 'true');
    row.classList.add('gems-dd-remove-pending');
    this.status('');
    return this.enqueueMutation(function () { return fetch(route('cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Gems-Cart-Source': INTERNAL_SOURCE },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(responseJson).then(validateCart)
      .catch(async function (error) {
        // Reconcile an ambiguous/lost response without repeating the write.
        var latest;
        try { latest = await this.fetchCart(); } catch (_) { throw error; }
        if (latest && Array.isArray(latest.items) && !latest.items.some(function (item) { return item.key === key; }) &&
          (!latest.item_count || (variantId && !latest.items.some(function (item) { return String(item.variant_id) === variantId; })))) return latest;
        throw error;
      }.bind(this))
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart response');
        this.updateCounts(cart.item_count);
        if (cart.item_count === 0) {
          // Keep the last row visible until its container is hidden. No empty-state flash.
          return this.closeEmptyPopover().then(function () { row.remove(); });
        }
        return this.animateRemoval(row);
      }.bind(this)); }.bind(this))
      .catch(function (error) {
        row.classList.remove('gems-dd-remove-pending', 'gems-dd-removing');
        row.style.removeProperty('max-height');
        row.removeAttribute('aria-busy');
        button.disabled = false;
        button.removeAttribute('aria-busy');
        this.status(this.root && this.root.getAttribute('data-dd-remove-error') || error.message);
        console.warn('[GEMS cart] Remove failed.', error);
      }.bind(this))
      .finally(function () {
        this.removing.delete(key);
        return release();
      }.bind(this));
  };
  CartController.prototype.animateRemoval = function (row) {
    if (!row.isConnected) return Promise.resolve();
    if (!row.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      row.remove(); return Promise.resolve();
    }
    // Hold the outer surface while a confirmed removal fades; no height-collapse bounce.
    var animation = row.animate([{ opacity: .58 }, { opacity: 0 }], { duration: 100, easing: 'ease-out' });
    return animation.finished.catch(function () {}).then(function () { row.remove(); animation.cancel(); });
  };
  CartController.prototype.resetTipPosition = function (bubble) {
    if (!bubble) return;
    ['left', 'right', 'top', 'bottom', 'max-width', 'max-height', 'display', '--gemsTipW'].forEach(function (property) {
      bubble.style.removeProperty(property);
    });
  };
  // Match the cart-page popup: align to its button, then constrain it to
  // the visible cart and viewport. Keep it inside the cart's clipping surface.
  CartController.prototype.positionTip = function (tip) {
    if (!this.root || !tip || tip.getAttribute('data-open') !== 'true') return;
    var button = tip.querySelector('.gems-info-tip__btn');
    var bubble = tip.querySelector('.gems-info-tip__bubble');
    if (!button || !bubble) return;
    this.resetTipPosition(bubble);
    bubble.style.display = 'block';
    var viewport = window.visualViewport;
    var viewportLeft = viewport ? viewport.offsetLeft : 0;
    var viewportTop = viewport ? viewport.offsetTop : 0;
    var viewportWidth = viewport ? viewport.width : document.documentElement.clientWidth;
    var viewportHeight = viewport ? viewport.height : window.innerHeight;
    var containerRect = this.root.getBoundingClientRect();
    var buttonRect = button.getBoundingClientRect();
    var wrapRect = tip.getBoundingClientRect();
    var minX = Math.max(viewportLeft, containerRect.left) + 12;
    var maxX = Math.min(viewportLeft + viewportWidth, containerRect.right) - 12;
    var width = Math.max(0, Math.min(360, maxX - minX));
    var left = Math.max(minX, Math.min(buttonRect.right - width, maxX - width));
    bubble.style.setProperty('--gemsTipW', width + 'px');
    bubble.style.maxWidth = width + 'px';
    bubble.style.left = (left - wrapRect.left) + 'px';
    bubble.style.right = 'auto';
    var minY = Math.max(viewportTop, containerRect.top) + 12;
    var maxY = Math.min(viewportTop + viewportHeight, containerRect.bottom) - 12;
    var above = Math.max(0, buttonRect.top - minY - 8);
    var below = Math.max(0, maxY - buttonRect.bottom - 8);
    var height = bubble.getBoundingClientRect().height;
    var useAbove = above >= height || above >= below;
    bubble.style.top = useAbove ? 'auto' : (buttonRect.bottom - wrapRect.top + 8) + 'px';
    bubble.style.bottom = useAbove ? (wrapRect.bottom - buttonRect.top + 8) + 'px' : 'auto';
    bubble.style.maxHeight = (useAbove ? above : below) + 'px';
  };
  CartController.prototype.closeTips = function (except) {
    if (!this.root) return;
    this.root.querySelectorAll('.gems-info-tip[data-open="true"]').forEach(function (tip) {
      if (tip === except) return;
      tip.setAttribute('data-open', 'false');
      var toggle = tip.querySelector('.gems-info-tip__btn');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      this.resetTipPosition(tip.querySelector('.gems-info-tip__bubble'));
    }.bind(this));
  };
  CartController.prototype.onClick = function (event) {
    if (!this.root || !this.root.isConnected) this.mount();
    var cartToggle = event.target.closest && event.target.closest(
      '[data-gems-cart-toggle], [data-cart-preview], [data-cart-preview-pc]'
    );
    if (cartToggle && (!this.root || !this.root.contains(cartToggle))) {
      if (!this.internalClose && cartToggle.getAttribute('aria-expanded') !== 'true') this.commit({ source: 'cart-open', immediate: true });
    }
    if (!this.root) return;
    var remove = event.target.closest && event.target.closest('[data-dd-remove]');
    if (remove && this.root.contains(remove)) {
      event.preventDefault(); event.stopPropagation(); this.remove(remove); return;
    }
    var toggle = event.target.closest && event.target.closest('.gems-info-tip__btn');
    if (toggle && this.root.contains(toggle)) {
      event.preventDefault(); event.stopPropagation();
      var tip = toggle.closest('.gems-info-tip');
      var opening = tip.getAttribute('data-open') !== 'true';
      this.closeTips(opening ? tip : null);
      tip.setAttribute('data-open', String(opening));
      toggle.setAttribute('aria-expanded', String(opening));
      if (opening) this.positionTip(tip);
      return;
    }
    var close = event.target.closest && event.target.closest('.gems-info-tip__close');
    if (close && this.root.contains(close)) {
      event.preventDefault(); event.stopPropagation();
      var parent = close.closest('.gems-info-tip');
      this.closeTips();
      var opener = parent && parent.querySelector('.gems-info-tip__btn');
      if (opener) opener.focus({ preventScroll: true });
      return;
    }
    if (!event.target.closest || !event.target.closest('.gems-info-tip')) this.closeTips();
  };
  CartController.prototype.onKeydown = function (event) {
    if (event.key !== 'Escape' || !this.root) return;
    var tip = this.root.querySelector('.gems-info-tip[data-open="true"]');
    if (!tip) return;
    event.preventDefault();
    event.stopPropagation();
    var toggle = tip.querySelector('.gems-info-tip__btn');
    this.closeTips();
    if (toggle) toggle.focus({ preventScroll: true });
  };
  CartController.prototype.onResize = function () {
    this.bindScrollState();
    if (!this.root) return;
    this.root.querySelectorAll('.gems-info-tip[data-open="true"]').forEach(this.positionTip.bind(this));
  };
  CartController.prototype.bindScrollState = function () {
    if (this.scrollList && this.scrollHandler) this.scrollList.removeEventListener('scroll', this.scrollHandler);
    if (!this.root) return;
    var viewport = this.root.querySelector('.dd-products-viewport');
    var list = this.root.querySelector('.products-list');
    if (!viewport || !list) return;
    var update = function () {
      var scrollable = list.scrollHeight > list.clientHeight + 2;
      viewport.classList.toggle('is-scrollable', scrollable);
      viewport.classList.toggle('is-at-top', list.scrollTop <= 2);
      viewport.classList.toggle('is-at-bottom', list.scrollTop + list.clientHeight >= list.scrollHeight - 2);
    };
    this.scrollList = list;
    this.scrollHandler = update;
    list.addEventListener('scroll', update, { passive: true });
    window.requestAnimationFrame(update);
  };
  var controller = new CartController();
  window.GemsCart = controller;
  window.GemsCartDropdown = controller;
  function installMutationBridge() {
    if (window.__gemsCartMutationBridgeInstalled) return;
    window.__gemsCartMutationBridgeInstalled = true;
    if (typeof window.fetch === 'function') {
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = requestUrl(input);
        var method = requestMethod(input, init);
        var source = headerValue(init && init.headers, 'X-Gems-Cart-Source');
        var promise = nativeFetch.apply(this, arguments);
        if (method === 'GET' || !CART_MUTATION_RE.test(url) || source === INTERNAL_SOURCE) return promise;
        promise.then(function (response) {
          if (response && response.ok) controller.commit({ source: source || 'fetch-cart-mutation' });
        }).catch(function () {});
        return promise;
      };
    }
    if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
      var proto = window.XMLHttpRequest.prototype;
      var nativeOpen = proto.open;
      var nativeSend = proto.send;
      var nativeSetHeader = proto.setRequestHeader;
      proto.open = function (method, url) {
        this.__gemsCartRequest = { method: String(method || 'GET').toUpperCase(), url: String(url || ''), source: '' };
        return nativeOpen.apply(this, arguments);
      };
      proto.setRequestHeader = function (name, value) {
        if (this.__gemsCartRequest && String(name || '').toLowerCase() === 'x-gems-cart-source') {
          this.__gemsCartRequest.source = String(value || '');
        }
        return nativeSetHeader.apply(this, arguments);
      };
      proto.send = function () {
        var xhr = this;
        var meta = xhr.__gemsCartRequest;
        if (meta && meta.method !== 'GET' && CART_MUTATION_RE.test(meta.url) && meta.source !== INTERNAL_SOURCE) {
          xhr.addEventListener('loadend', function () {
            if (xhr.status >= 200 && xhr.status < 300) controller.commit({ source: meta.source || 'xhr-cart-mutation' });
          }, { once: true });
        }
        return nativeSend.apply(this, arguments);
      };
    }
  }
  installMutationBridge();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { controller.mount(); }, { once: true });
  } else {
    controller.mount();
  }
})();
